<template>
  <lf-checkbox-dropdown
    ref="checkboxDropdown"
    class="note-type-filter border"
    :class="
      checkboxDropdown?.showMenu ? 'border-primary' : 'border-transparent'
    "
    :custom-dropdown-icon-color="
      checkboxDropdown?.showMenu ? 'text-primary' : 'text-gray-400'
    "
    :options="options"
    :placeholder="$t('COMMON.TYPE')"
    :custom-label="customLabel"
    :name="$t('COMMON.TYPE')"
    width-full
    no-margin
    :model-value="convertToArray(selected)"
    :render-component="TypeFIlterOption"
    :render-component-options="renderComponentOptions"
    @update:model-value="handleApplyFilter"
  >
    <template #header>
      <div class="flex items-center justify-between px-4 py-2">
        <div class="flex items-center space-x-1">
          <lf-h4>{{ $t("COMMON.TYPE") }}</lf-h4>
        </div>
        <button class="text-error" @click="handleApplyFilter([])">
          {{ t("COMMON.CLEAR") }}
        </button>
      </div>
    </template>
  </lf-checkbox-dropdown>
</template>

<script setup lang="ts">
import { computed, ref, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

import capitalize from "lodash/capitalize";

import { NoteType } from "@/enums/dealActivity";
import { convertToArray } from "@/helpers/common";

import TypeFIlterOption from "@/components/deals/dealActivity/notes/TypeFilterOption.vue";
import LfCheckboxDropdown from "@/components/ui/inputs/LfCheckboxDropdown.vue";
import LfH4 from "@/components/ui/text/LfHeading4.vue";

const { t } = useI18n();

const emit = defineEmits<{
  "value:changed": [NoteType[]];
}>();

const options = Object.values(NoteType).reduce(
  (acc, noteType) => {
    acc[noteType] = capitalize(noteType);
    return acc;
  },
  {} as Record<NoteType, string>
);

const selected = ref<NoteType[]>([]);
const checkboxDropdown = useTemplateRef("checkboxDropdown");

const renderComponentOptions = computed(() => ({
  selected: selected.value,
}));

const customLabel = computed(() => {
  const selectedNoteType = selected.value.length
    ? ` | ${capitalize(selected.value[0])}`
    : "";
  return `${t("COMMON.TYPE")} ${selectedNoteType}`;
});

const handleApplyFilter = async (value: unknown[]) => {
  const selectedOptions = value as NoteType[];
  selected.value = selectedOptions.length
    ? [selectedOptions[selectedOptions.length - 1]]
    : [];

  emit("value:changed", selected.value);
};
</script>
<style>
@reference "@/assets/tailwind.css";

.note-type-filter {
  & div,
  label {
    @apply w-full;
  }
  & input[type="checkbox"] {
    @apply hidden;
  }
  & .dropdown-button {
    @apply min-w-17 border-none bg-grey-hover;

    & > span {
      @apply mr-0 ml-0;
    }
    & .dropdown-label {
      @apply pr-7;
    }
  }
}
</style>
